var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0833 6.66667V13.5C17.0833 14.9001 17.0833 15.6002 16.8108 16.135C16.5712 16.6054 16.1887 16.9878 15.7183 17.2275C15.1835 17.5 14.4835 17.5 13.0833 17.5H6.91667C5.51653 17.5 4.81647 17.5 4.28169 17.2275C3.81128 16.9878 3.42883 16.6054 3.18915 16.135C2.91667 15.6002 2.91667 14.9001 2.91667 13.5V6.66667M3 2.5H17C17.4667 2.5 17.7001 2.5 17.8783 2.59083C18.0351 2.67072 18.1626 2.79821 18.2425 2.95501C18.3333 3.13327 18.3333 3.36662 18.3333 3.83333V5.33333C18.3333 5.80004 18.3333 6.0334 18.2425 6.21166C18.1626 6.36846 18.0351 6.49594 17.8783 6.57584C17.7001 6.66667 17.4667 6.66667 17 6.66667H3C2.53329 6.66667 2.29993 6.66667 2.12167 6.57584C1.96487 6.49594 1.83739 6.36846 1.75749 6.21166C1.66667 6.0334 1.66667 5.80004 1.66667 5.33333V3.83333C1.66667 3.36662 1.66667 3.13327 1.75749 2.95501C1.83739 2.79821 1.96487 2.67072 2.12167 2.59083C2.29993 2.5 2.53329 2.5 3 2.5ZM8 9.58333H12C12.4667 9.58333 12.7001 9.58333 12.8783 9.67416C13.0351 9.75406 13.1626 9.88154 13.2425 10.0383C13.3333 10.2166 13.3333 10.45 13.3333 10.9167V11.5833C13.3333 12.05 13.3333 12.2834 13.2425 12.4617C13.1626 12.6185 13.0351 12.7459 12.8783 12.8258C12.7001 12.9167 12.4667 12.9167 12 12.9167H8C7.53329 12.9167 7.29993 12.9167 7.12167 12.8258C6.96487 12.7459 6.83739 12.6185 6.75749 12.4617C6.66667 12.2834 6.66667 12.05 6.66667 11.5833V10.9167C6.66667 10.45 6.66667 10.2166 6.75749 10.0383C6.83739 9.88154 6.96487 9.75406 7.12167 9.67416C7.29993 9.58333 7.53329 9.58333 8 9.58333Z",
    stroke: "currentColor",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.3338558eedb486d25706ec7929aeba6d.svg";
export { ForwardRef as ReactComponent };